import ReactDOM from "react-dom";
import App from "./App";
import { auth, FirebaseProvider } from "./context/FirebaseContext";
import { UserBackgroundProvider } from "./context/UserBackgroundContext";
import { installRuntimeDomGuards } from "./utility/runtimeDomGuards";
import { installChunkLoadRecovery } from "./utility/chunkLoadRecovery";
import { installGoogleAnalyticsAuthGuard } from "./analytics/googleAnalytics";
import {
  applyDocumentLanguage,
  getInitialLanguagePreference
} from "./i18n/language";

installRuntimeDomGuards();
installChunkLoadRecovery();
installGoogleAnalyticsAuthGuard(auth);
applyDocumentLanguage(getInitialLanguagePreference().language);

ReactDOM.render(
  <FirebaseProvider>
    <UserBackgroundProvider>
      <App />
    </UserBackgroundProvider>
  </FirebaseProvider>,
  document.getElementById("root")
);
